import { useContext, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { AddressInput } from 'lib/types/core'
import { CoreContext } from 'lib/core/resources/context'
import { me } from 'lib/core/data/customer/me'
import { Toast } from 'lib/ui/components'
import { useCheckout, useCheckoutContext } from 'lib/modules/checkout'
import { ShippingAddressInput } from 'lib/types'

export const useCustomerAddress = () => {
  const context = useContext(CoreContext)
  const dispatch = useDispatch()
  const history = useHistory()
  const [isFetching, setIsFetching] = useState(false)

  const updateAddress = async ({ address, id }: { address: AddressInput, id: number}) => {
    setIsFetching(true)
    try {
      await context.magentoClient?.customer.editCustomerAddress({ id, payload: address })
      await dispatch(me())
      Toast.toastSuccess({ messageId: 'customer.account.address.edit.success' })
      history.push('/customer/account/addresses')
    } catch (e) {
      Toast.toastFailure()
      // TODO: report to sentry
    }
    setIsFetching(false)
  }

  const createAddress = async ({ address }: { address: AddressInput}) => {
    setIsFetching(true)
    try {
      await context.magentoClient?.customer.createCustomerAddress({ payload: address })
      await dispatch(me())
      Toast.toastSuccess({ messageId: 'customer.account.address.add.success' })
      history.push('/customer/account/addresses')
    } catch (e) {
      Toast.toastFailure()
      // TODO: report to sentry
    }
    setIsFetching(false)
  }

  return {
    updateAddress,
    createAddress,
    isFetching
  }
}

export const useSetDefaultShippingAddressOnCart = () => {
  const { setShippingAddress } = useCheckout()
  const { setState } = useCheckoutContext()

  const updateCheckoutAddress = (address: AddressInput) => {
    const {
      city,
      countryCode,
      company,
      firstName,
      lastName,
      postalCode,
      regionCode,
      street,
      street2,
      phoneNumber,
      isDefaultShipping
    } = address

    const shippingAddress: ShippingAddressInput = {
      address: {
        city,
        countryCode,
        company,
        firstName,
        lastName,
        postalCode,
        regionCode,
        street,
        street2: street2 ?? '',
        phoneNumber
      }
    }

    if (isDefaultShipping) {
      setShippingAddress({ shippingAddress }, {
        debounce: true,
        callback: {
          onSuccess: () => {
            setState((state) => ({
              ...state,
              shippingErrors: {}
            }))
          }
        }
      })
    }
  }

  return {
    updateCheckoutAddress
  }
}
